<template>
  <div
    v-if="visible"
    class="c-profiles"
  >
    <component
      :is="view"
      class="c-profiles__view"
      :edit-mode="editMode"
      :selected-profile="selectedProfile"
      @action="action"
    ></component>
    <span
      v-if="showCloseArrow"
      class="c-profiles__icon-close o-icon o-icon--close o-typography--action"
      @click="close"
    ></span>
  </div>
</template>
<script>
  import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
  import { isKey, keyMap } from '@/shared/utils';
  import { EventType } from '@/shared/enums';
  import ProfileAction from './profile-action';
  import UiProfileAdd from './add.vue';
  import UiProfileEdit from './edit.vue';
  import UiProfileList from './list.vue';

  export default {
    components: {
      UiProfileAdd,
      UiProfileList,
    },
    data() {
      return {
        view: UiProfileList,
        visible: false,
        subscriber: this.$services.resolve('subscriber'),
        profilesService: this.$services.resolve('profiles'),
        profiles: [],
        editMode: true,
        selectedProfile: undefined,
        profileName: '',
        showCloseArrow: true,
      };
    },
    methods: {
      init() {
        if (!this.subscriber.isLogged) {
          return;
        }

        this.profiles = this.profilesService.collection.records;
      },
      switchProfile(profile) {
        this.subscriber.switchProfile(profile);
      },
      action(name, ...rest) {
        switch (name) {
          case ProfileAction.CLOSE:
            this.close();
            break;
          case ProfileAction.SHOW_ADD:
            this.view = UiProfileAdd;
            this.showCloseArrow = false;
            break;
          case ProfileAction.SHOW_EDIT:
            this.selectedProfile = rest[0];
            this.view = UiProfileEdit;
            this.showCloseArrow = false;
            break;
          case ProfileAction.SHOW_LIST:
            this.view = UiProfileList;
            this.showCloseArrow = true;
            break;
          case ProfileAction.SWITCH_PROFILE:
            this.switchProfile(rest[0]);
            this.close();
            break;
        }
      },
      show({ editMode }) {
        document.addEventListener('keyup', this.onKeyUp);
        this.editMode = editMode;
        this.selectedProfile = undefined;
        this.view = UiProfileList;
        this.visible = true;
        this.init();

        this.$nextTick(() => {
          disableBodyScroll(this.$el);
        });
      },
      close() {
        document.removeEventListener('keyup', this.onKeyUp);
        enableBodyScroll(this.$el);
        this.$EventBus.emit(EventType.RESIZE);
        this.visible = false;
      },
      onKeyUp(e) {
        if (isKey(keyMap.ESCAPE, e)) {
          this.close();
        }
      },
    },
  };
</script>
